/**
 * Events API — TanStack Query hook.
 *
 * Consumes `GET /api/events` (public, no auth). The shape mirrors the DTO
 * declared in `functions/api/events.ts`. When the API gains tenant scoping
 * (subdomain → tenant_id), this hook stays the same — the backend resolves it.
 */

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface EventDay {
  date: string;        // YYYY-MM-DD
  label: string | null;
}

export interface FestivalEvent {
  id: string;
  slug: string;
  name: string;
  timezone: string;
  created_at: string;
  days: EventDay[];
}

interface EventsResponse {
  events: FestivalEvent[];
}

export function useEvents() {
  return useQuery({
    queryKey: ["events"],
    queryFn: () => api<EventsResponse>("/api/events"),
    staleTime: 60_000,
    select: (data) => data.events,
  });
}
